import { useEffect } from 'react'

interface UseJourneySaveProps {
    isDraft: boolean
    saving: boolean
    saveSteps: () => Promise<void>
}

export function useJourneySave({ isDraft, saving, saveSteps }: UseJourneySaveProps) {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const isMac = navigator.userAgent.toUpperCase().includes('MAC')
            const isCtrlOrCmd = isMac ? event.metaKey : event.ctrlKey

            if (!isCtrlOrCmd) return

            if (event.key === 's' || event.key === 'S') {
                event.preventDefault()
                if (isDraft && !saving) {
                    void saveSteps()
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [isDraft, saving, saveSteps])
}
